module.exports = __webpack_public_path__ + "img/Plate glass.99dfd3b0.svg";